import "./index.scss";

function PlatformLoader({ visible = true, label = "Cargando contenido" }) {
  if (!visible) return null;

  return (
    <div
      className="platform-loader"
      role="status"
      aria-live="polite"
      aria-label={label}
    >
      <div className="platform-loader__mark" aria-hidden="true">
        <span className="platform-loader__orbit" />
        <span className="platform-loader__logo-shell">
          <img
            className="platform-loader__logo"
            src="/img/default-profile.jpg"
            alt=""
          />
        </span>
      </div>
      <span className="platform-loader__label">{label}</span>
    </div>
  );
}

export { PlatformLoader };
